import React from 'react';
import NarwhalLogo from './narwhal-logo';
import PatrimonyChart from './patrimony-chart';
import theme from '../styles/theme';
import { formatCurrency } from '../utils/financial-calculations';

const ResultsModal = ({ 
  showResults, 
  closeModal, 
  finalAmount, 
  monthlyIncome, 
  chartData 
}) => {
  if (!showResults) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-screen overflow-y-auto">
        <div className="flex justify-between items-center p-6" style={{ backgroundColor: theme.colors.azul }}>
          <div className="flex items-center">
            <NarwhalLogo />
            <h2 className="ml-4 text-2xl font-bold text-white">Resultados da sua Aposentadoria</h2>
          </div>
          <button onClick={closeModal} className="text-white text-xl hover:text-gray-300">
            ✕
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 rounded-lg border" style={{ backgroundColor: theme.colors.offwhite, borderColor: theme.colors.azul }}>
              <h3 className="text-xl font-bold mb-4" style={{ color: theme.colors.azul }}>Seu patrimônio na aposentadoria será: (Nominal)</h3>
              <p className="text-3xl font-bold" style={{ color: theme.colors.ouro }}>{formatCurrency(finalAmount)}</p>
            </div>
            
            <div className="p-6 rounded-lg border" style={{ backgroundColor: theme.colors.offwhite, borderColor: theme.colors.azul }}>
              <h3 className="text-xl font-bold mb-4" style={{ color: theme.colors.azul }}>Sua renda mensal na aposentadoria será: (Já corrigida pela Inflação)</h3>
              <p className="text-3xl font-bold" style={{ color: theme.colors.ouro }}>{formatCurrency(monthlyIncome)}</p>
            </div>
          </div>
          
          <div className="mt-8">
            <h3 className="text-xl font-bold mb-4" style={{ color: theme.colors.azul }}>Evolução Patrimonial</h3>
            <PatrimonyChart data={chartData} />
          </div>
          
          <div>
          <button
            onClick={() => window.location.href = 'https://narwhalcapital.com.br/#contato'}
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg 
             transition duration-300 ease-in-out transform hover:scale-105">
            Seu futuro começa aqui, clique agora!
          </button>

          </div>

          <div className="mt-8 p-6 rounded-lg border" style={{ backgroundColor: theme.colors.offwhite, borderColor: theme.colors.ouro }}>
            <h3 className="text-lg font-bold mb-2" style={{ color: theme.colors.azul }}>Observações importantes:</h3>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>Os valores são projeções baseadas nos parâmetros fornecidos.</li>
              <li>Inflação e retornos podem variar ao longo do tempo.</li>
              <li>Considere revisar seu plano anualmente para ajustes necessários.</li>
              <li>Esta simulação não considera impostos ou outros custos específicos.</li>
              <li>Metodologia de calculo - Juros compostos com capitalização mensal.</li>
              <li> FV = PMT * ((1 + i)^n - 1) / i </li>
              <li>Consulte um especialista da Narwhal Capital para um planejamento personalizado.</li>
            </ul>
          </div>
          
          <div className="text-center mt-6">
            <p className="text-sm font-medium" style={{ color: theme.colors.azul }}>NARWHAL CAPITAL</p>
            <p className="text-sm" style={{ color: theme.colors.ouro }}>VOCÊ, INDEPENDENTE</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultsModal;
